<template>
  <div class="expert-jion">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>

    <div class="expert-jion-wrap">
      <!-- 服务名称 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 20px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          服务名称
        </div>
        <div class="userinput" style="float: left">
          <input type="text" placeholder="请输入服务名称" ref="projectName" />
        </div>
      </div>
      <!-- 服务图片 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 20px;
            height: 100px;
            line-height: 100px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          服务图片
        </div>
        <div style="width: 400px; overflow: hidden; float: left">
          <div style="width: 100%; overflow: hidden">
            <el-upload
              class="avatar-uploader"
              action="/v1/cloud/user/expert/upload/img"
              :show-file-list="false"
              :on-success="handleSuccess2"
              :on-error="handleError2"
              :before-upload="beforeAvatarUpload2"
            >
              <img v-if="coverImage" :src="coverImage" class="avatar" />
              <div style="width: 170px; height: 100px" v-show="!coverImage">
                <img
                  src="../../static/common/upload_image.png"
                  style="
                    dispaly: block;
                    width: 34px;
                    height: 33px;
                    margin: 0px 67px;
                    position: absolute;
                    left: 0px;
                    top: 24px;
                  "
                />
                <div
                  style="
                    color: #3476C1;
                    position: absolute;
                    left: 0px;
                    top: 24px;
                    width: 170px;
                    text-align: center;
                  "
                >
                  点击此处上传
                </div>
              </div>
            </el-upload>
            <!-- <div style="width:218px;float:left;height:100px;margin-left:10px;">
                        <div style="font-size:12px;line-height:12px;margin-top:43px;font-family:MicrosoftYaHei;font-weight:400;color:#999999;">logo 为非必填项</div>
                    </div> -->
            <div
              style="
                width: 218px;
                float: left;
                height: 100px;
                margin-left: 10px;
              "
              v-show="!coverImage"
            >
              <div
                style="
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 43px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: #999999;
                "
              >
                可上传png、jpg、gif、svg等格式的图片
              </div>
            </div>
            <div
              style="
                width: 218px;
                float: left;
                height: 100px;
                margin-left: 10px;
              "
              v-show="coverImage"
            >
              <div
                style="
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 33px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: #999999;
                "
              >
                可上传png、jpg、gif、svg等格式的文件
              </div>
              <div
                style="
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 10px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: #999999;
                "
              >
                如需更换图片，请点击图片可再次上传
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 服务类型 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 20px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          服务类型
        </div>
        <div class="iselect" style="float: left">
          <Select
            v-model="sel_territory"
            style="width: 200px; height: 40px"
            placeholder="请选择服务类型"
          >
            <Option
              v-for="item in industryList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
      </div>

      <!-- 联系电话 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 20px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          联系电话
        </div>
        <div class="userinput" style="float: left">
          <input type="text" placeholder="请输入您的联系电话" ref="phoneNum" />
        </div>
      </div>
      <!-- 所在地区 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 20px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          所在地区
        </div>
        <div style="width: 350px; float: left" class="infor-area">
          <Select
            v-model="formValidate.province"
            style="width: 110px; margin-right: 8px; height: 50px"
            @on-change="changeProvince"
            :placeholder="defaultAddress.province"
          >
            <Option
              v-for="item in provinceArr"
              :value="item.encoded"
              :key="item.encoded"
              >{{ item.name }}</Option
            >
          </Select>
          <Select
            v-model="formValidate.city"
            style="width: 110px; margin-right: 8px; height: 50px"
            @on-change="changeCity"
            :placeholder="defaultAddress.city"
          >
            <Option
              v-for="item in cityArr"
              :value="item.encoded"
              :key="item.encoded"
              >{{ item.name }}</Option
            >
          </Select>
          <Select
            v-model="formValidate.county"
            style="width: 110px; margin-right: 0px; height: 50px"
            @on-change="changeCounty"
            :placeholder="defaultAddress.county"
          >
            <Option
              v-for="item in countyArr"
              :value="item.encoded"
              :key="item.encoded"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
      </div>
      <!-- 通讯详细地址 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 20px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          通讯详细地址
        </div>
        <div class="userinput" style="float: left">
          <input
            type="text"
            placeholder="请输入通讯详细地址（精确到门牌号）"
            ref="address"
          />
        </div>
      </div>

      <!-- 服务简介 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 20px;
            height: 58px;
            line-height: 58px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          服务简介
        </div>
        <div style="float: left; width: 350px">
          <textarea
            maxlength="50"
            placeholder="请输入50字以内的服务简介"
            v-model="individualResume"
            style="
              width: 350px;
              height: 100px;
              background: rgba(250, 250, 250, 1);
              border: 1px solid rgba(238, 238, 238, 1);
              border-radius: 4px;
              outline: none;
              padding: 18px 9px;
            "
          ></textarea
          >
        </div>
      </div>

      <!-- 服务详情 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 20px;
            height: 58px;
            line-height: 58px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          服务详情
        </div>
        <div style="float: left; width: 350px">
          <textarea
            maxlength="500"
            placeholder="请输入服务详情（500字左右，不能少于100字）"
            v-model="individualResume2"
            style="
              width: 350px;
              height: 200px;
              background: rgba(250, 250, 250, 1);
              border: 1px solid rgba(238, 238, 238, 1);
              border-radius: 4px;
              outline: none;
              padding: 18px 9px;
            "
          ></textarea
          >
        </div>
      </div>

      <!-- 服务价格 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 134px;
            text-align: right;
            margin-right: 20px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          服务价格
        </div>
        <div class="userinput" style="float: left">
          <input type="text" placeholder="请输入价格（单位：元）" ref="money" />
        </div>
      </div>

      <!-- 清除浮动 -->
      <div style="clear: both"></div>
      <!-- 协议 -->
      <div
        style="
          width: 350px;
          height: 12px;
          line-height: 12px;
          margin-top: 40px;
          margin-left: 165px;
        "
      >
        <img
          :src="agreementFlag == 1 ? img2 : img1"
          alt=""
          style="
            display: block;
            width: 12px;
            height: 12px;
            float: left;
            margin-right: 10px;
            cursor: pointer;
          "
          @click="isOrFn('agreement', 1)"
        />
        <div
          style="
            float: left;
            width: 300px;
            height: 12px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          <span style="color: #666666">我已确认并同意</span>
          <span style="color: #3476C1">《服务上传协议》</span>
          <span style="color: #666666">中事项和要求</span>
        </div>
      </div>
      <div class="go" @click="submitFn()">提交</div>
    </div>

    <div style="width: 100%; height: 50px"></div>
  </div>
</template>

<script>
// import helloworld from '@/components/helloworld.vue' //引入组件
import navigation from "@/components/common/navigation";

import areasData from "@/assets/areas.json";

export default {
  name: "serve-upload",
  components: {
    navigation,
  },
  data() {
    return {
      userInfor: {},
      img1: require("../../static/login/i6.png"), //单选图标
      img2: require("../../static/login/i7.png"),
      isOr1: 1, //是否
      isOr2: 1, //是否
      isOr3: 1, //是否
      isOr4: 1, //是否
      testList: ["小学生", "中学生", "大学生"],
      industryList: [],
      //员工规模
      scaleList: [
        "少于5人",
        "5-10人",
        "10-20人",
        "20-50人",
        "50-100人",
        "100人以上",
      ],
      //融资阶段
      financingList: [
        "未融资",
        "种子轮",
        "天使轮",
        "Pre-A",
        "A轮",
        "A+轮",
        "Pre-B",
        "B轮",
        "B+轮",
        "Pre-C",
        "C轮",
        "C+轮",
        "Pre-D",
        "D轮",
        "D+轮",
        "Pre-E",
        "E轮",
        "E+轮",
        "Pre-IPO",
        "IPO",
        "并购",
        "股权转让",
        "定向增发",
        "战略投资",
        "新三板",
        "不明确",
        "自筹资金",
      ],
      fileList: [],
      uploadList: [],
      resFileUrl: "",
      coverImage: "",
      uploadCover: "",
      sel_territory: "",
      sel_qualifications: "",
      sel_politic: "",
      individualResume: "", //简介
      individualResume2: "", //详情
      agreementFlag: 0,
      //省市区数据
      provinceArr: areasData.data,
      cityArr: [],
      countyArr: [],
      formValidate: {
        province: "",
        city: "",
        county: "",
      },
      defaultAddress: {
        province: "请选择",
        city: "请选择",
        county: "请选择",
      },
      provinceCode: 0,
      cityCode: 0,
      countyCode: 0, //地区编码
    };
  },
  methods: {
    handlePreview(file) {
      console.log(file);
    },
    handleError(err, file, fileList) {
      // console.log('000',err,file, fileList);
      this.$message.error("文件太大，请压缩后上传");
    },
    handleRemove(file, fileList) {
      console.log(111, file, fileList);
      let list = [];
      if (fileList) {
        fileList.forEach((item, index, array) => {
          list.push(item.response);
        });
      }
      this.uploadList = list;
      //删除服务器上文件
      let imgUrl = file.response;
      this.$axios
        .post("/v1/cloud/user/expert/upload/certificate/delete", {
          url,
        })
        .then(({ data }) => {})
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },
    handleError2(res) {
      if (res.status == 401) {
        this.$router.push({ name: "login" });
      } else if (res.status == 400) {
        this.$message.error("文件太大，请压缩后上传");
      }
    },
    handleSuccess(res, file, fileList) {
      console.log(222, res, file, fileList);
      this.resFileUrl = res;
      let list = [];
      if (fileList) {
        fileList.forEach((item, index, array) => {
          list.push(item.response);
        });
      }
      this.uploadList = list;
      console.log(222, this.uploadList, list);
    },
    handleSuccess2(res, file) {
      this.coverImage = URL.createObjectURL(file.raw);
      this.uploadCover = res;
    },
    beforeAvatarUpload2(file) {
      // const isJPG = file.type === 'image/jpeg';
      // const isLt2M = file.size / 1024 / 1024 < 0.2;
      // if (!isJPG) {
      // this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // if (!isLt2M) {
      // this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      // return isJPG && isLt2M;
    },
    toExpert() {
      this.$router.push("/Expert");
    },
    isOrFn(type, val) {
      console.log(type);
      if (type == "1") {
        this.isOr1 = val;
      } else if (type == "2") {
        this.isOr2 = val;
      } else if (type == "3") {
        this.isOr3 = val;
      } else if (type == "4") {
        this.isOr4 = val;
      } else if (type === "agreement") {
        if (this.agreementFlag === 1) {
          this.agreementFlag = 0;
        } else {
          this.agreementFlag = 1;
        }
      } else {
      }
    },
    submitFn() {
      let param = {
        name: this.$refs.projectName.value,
        coverImg: this.uploadCover,
        catalogueId: this.sel_territory,
        // companyName;
        phoneNum: this.$refs.phoneNum.value,
        address: this.$refs.address.value,
        baseRemark: this.individualResume, //简介
        remark: this.individualResume2, //详情
        money: this.$refs.money.value,

        provinceCode: this.provinceCode, //省
        cityCode: this.cityCode, //市
        areaCode: this.countyCode, //区
      };
      console.log("上传项目", param);
      this.$axios
        .post("/v1/cloud/user/services/upload", param)
        .then(({ data }) => {
          if (data) {
            this.$message({
              showClose: true,
              message: "上传成功，需要1-3个工作日审核信息！",
              type: "success",
            });
            this.$router.push("/serve");
          }
        })
        .catch((error) => {
          var err = error.response;
          if (err.status == 400) {
            this.$Message.error(err.data.message);
          }
          if (err.status == 401) {
            this.$router.push({ name: "login" });
          } else {
            this.$message.error(error.response.data.message);
          }
        });
    },
    changeProvince(val) {
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (this.formValidate.province == this.provinceArr[i].encoded) {
          this.cityArr = this.provinceArr[i].cityRespList;
          this.formValidate.county = "";
          this.countyArr = [];
        }
      }
      this.provinceCode = val;
    },
    changeCity(val) {
      for (var i = 0; i < this.cityArr.length; i++) {
        if (this.formValidate.city == this.cityArr[i].encoded) {
          this.countyArr = this.cityArr[i].countyRespList;
        }
      }
      this.cityCode = val;
    },
    changeCounty(s) {
      console.log("区", s, this.formValidate.county);
      this.countyCode = s;
    },
  },
  created() {
    //服务类型
    this.$axios.get("/v1/cloud/common/services/catalogue").then(({ data }) => {
      if (data) {
        // data.shift()
        this.industryList = data;
      }
    });
    //是否登录校验
    if (!localStorage.token) {
      this.$router.push({ name: "login" });
    }
  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  },
};
</script>

<style lang="less">
::-webkit-input-placeholder {
    color: #999999 !important;
    font-family: MicrosoftYaHei;
}
.ivu-select-selection {
  height: 40px !important;
  line-height: 40px !important;
}
.ivu-select-placeholder,
.ivu-select-selected-value {
  height: 40px !important;
  line-height: 40px !important;
}

//最多上传九个图片
.upload-nine {
  // width:170px;float: left;
  .el-upload-dragger {
    height: 100px;
    border: none;
  }
}
//上传图片
.avatar-uploader .el-upload {
  // border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
  float: left;
  width: 170px !important;
  height: 100px !important;
  line-height: 100px !important;
  background: rgba(250, 250, 250, 1);
  border: 1px solid rgba(238, 238, 238, 1);
}
.avatar-uploader-l .el-upload {
  margin-left: 8px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 182px;
  height: 115px;
  line-height: 115px;
  text-align: center;
}
.avatar {
  width: 182px;
  height: 115px;
  display: block;
}

input {
  outline: none;
  border: none;
  background: rgba(0, 0, 0, 0);
}
.expert-jion {
  width: 100%;
  background-color: #F5F5F5;
  .expert-jion-wrap {
    width: 1200px;
    height: auto;
    margin: 0 auto;
    padding-left: 300px;
    margin-top: 30px;
    overflow: hidden;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(238, 238, 238, 1);
    .userinput {
      width: 350px;
      height: 40px;
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      padding-left: 9px;
      input {
        float: left;
        width: 300px;
        height: 100%;
      }
    }
    .userinfor {
      width: 350px;
      height: 40px;
      line-height: 40px;
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      padding-left: 4px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #999999;
    }
    //iview 下拉框组件
    .iselect {
      .ivu-select {
        width: 350px !important;
        height: 50px !important;
        line-height: 50px;
      }
      .ivu-select-selection {
        height: 50px;
        line-height: 50px;
        background: rgba(250, 250, 250, 1);
      }
      .ivu-select-single .ivu-select-selection {
        outline: none;
        width: 350px;
        height: 50px;
        line-height: 50px;
      }
      .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
      .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        width: 350px;
        height: 50px;
        line-height: 50px;
      }
    }
    .infor-area {
      .ivu-select-selection {
        height: 50px;
        line-height: 50px;
        background: rgba(250, 250, 250, 1);
      }
      .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
      .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        width: 350px;
        height: 50px;
        line-height: 50px;
        color: #999999;
        width: 110px;
      }
      .ivu-select-single .ivu-select-selection {
        height: 50px;
      }
    }
    .go {
      margin-top: 20px;
      margin-bottom: 50px;
      margin-left: 165px;
      width: 350px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #3476C1;
      border-radius: 4px;
      cursor: pointer;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>